import styled from 'styled-components';

export const ChatWidget = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #6146d7;
  border-radius: 50px;
  padding: 12px 18px;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  z-index: 9999;
  border: none;
  outline: none;
`;

export const ChatWindow = styled.div`
  position: fixed;
  bottom: 80px;
  right: 30px;
  width: 500px;
  height: 600px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 3px 18px rgba(0, 0, 0, 0.16);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Header = styled.div`
  background: #6146d7;
  color: white;
  padding: 14px 16px;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
`;

export const SupportText = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #6146d7;
  text-align: center;
  padding: 8px 0;
  background: #f7f7fa;
  border-bottom: 1px solid #f0eff6;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  background: #f7f7fa;
`;

export const MessageRow = styled.div<{ from: 'bot' | 'user' }>`
  margin: 8px 0;
  display: flex;
  justify-content: ${({ from }) => (from === 'user' ? 'flex-end' : 'flex-start')};
`;

export const MessageBubble = styled.span<{ from: 'bot' | 'user' }>`
  background: ${({ from }) => (from === 'user' ? '#6146d7' : '#ececfa')};
  color: ${({ from }) => (from === 'user' ? 'white' : '#333')};
  border-radius: 16px;
  padding: 8px 14px;
  font-size: 15px;
  max-width: 80%;
  word-break: break-word;
`;

export const InputArea = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: #fff;
  border-top: 1px solid #efefef;
`;

export const InputField = styled.textarea`
  flex: 1;
  border: none;
  border-radius: 12px;
  padding: 8px 12px;
  font-size: 15px;
  margin-right: 8px;
  outline: none;
  background: transparent;
  resize: none;
`;

export const SendButton = styled.button<{ disabled?: boolean }>`
  background: transparent;
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ disabled }) => (disabled ? '#b3b3b3' : '#6146D7')};
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TypingIndicator = styled.div`
  color: #9399b2;
  font-size: 13px;
  margin-top: 10px;
  text-align: left;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 22px;
  cursor: pointer;
`;

export const FileName = styled.div`
  font-size: 12px;
  color: #6146d7;
  margin-left: 40px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;

  button {
    background: none;
    border: none;
    color: #6146d7;
    cursor: pointer;
    margin-left: 6px;
  }
`;

export const IconCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #6146d7;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  margin-right: 10px;
`;
